module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style4/menu-style4.component.scss
// module id = ./src/app/mega-menu/menu-style4/menu-style4.component.scss
// module chunks = main